export default __webpack_public_path__ + "static/media/for-business-arrows--rounded.e945792b.svg";